module.exports = __webpack_public_path__ + "images/rank-gains-blue-0fda8233.svg";